import { msg } from "@lingui/core/macro";

export const trimExpiredIntervalsRuleMessages = {
	name: msg({ message: "Trim Expired Intervals" }),
	description: msg({ message: "Removes intervals that have already ended" }),
	errors: {
		allIntervalsInPast: msg({
			message: "All selected intervals have already ended. Please choose times in the future.",
		}),
	},
} as const;
